import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import ReactSwipe from 'react-swipe';
import theme from 'ui/styles/theme';
import getRelativeUrl from 'utils/getRelativeUrl'
import { Link } from 'react-router-dom'

export default class JpnIconButton extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount = () => {
    }



    render() {
        const { bgcolor, icons } = this.props

        const { } = this.state




        return (
            <Wrapper bgcolor={bgcolor}>
                <InnerWrapper fluid>
                    {console.log(this.props)}
                    <ContainerButton>
                        {icons.map((item, index) =>
                            <ButtonWrapper key={index} to={getRelativeUrl(item.url.link)}>
                                <Icon picture={item.icon.sourceUrl}></Icon>
                                <Text>{item.text}</Text>
                                {item.text_translation &&
                                    <span>{item.text_translation}</span>
                                }
                            </ButtonWrapper>
                        )}
                    </ContainerButton>
                </InnerWrapper>
            </Wrapper>
        )
    }
}






const InnerWrapper = styled(Container)`
padding: 0 20px;
margin-bottom: 20px;
width: 100%;

${media.lg`
padding: 0 20%;
margin-top: 30px;
justify-content: space-between;
`}
`
const ButtonWrapper = styled(Link)`
width: 40%;
color: black;
text-decoration: none;
text-align: center;

span {
    color: grey;
}
`
const ContainerButton = styled.div`
display: flex;
flex-wrap: wrap;
justify-content: space-evenly;
`

const Icon = styled.div`
margin: auto;
content: " ";
background: url(${props => props.picture}) center / cover;
position: relative;
border-radius: 50%;
width: 50%;
height: auto;
padding-top: 50%;
background-color: rgba(0, 64, 119, 0.2);
box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;
`
const Text = styled.p`
margin-top: 15px;
text-align: center;
font-size: larger;
font-weight: 600;
margin-bottom:0;
`

const Wrapper = styled.div`
background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};
margin-top: 8%;

${media.lg`
margin-top: 0;
`}
`





// WEBPACK FOOTER //
// ./src/ui/components/modules/JPNIconButton/index.js